import { __awaiter } from "tslib";
import { AuthController } from 'src/services/api/common/ws/AuthController';
export class WebSocketApiWithAuth {
    constructor({ api, authController, }) {
        this.api = api;
        this.auth = authController || new AuthController({ api });
    }
    send(args, callback) {
        var _a, _b;
        return this.api.send(Object.assign(Object.assign({}, args), { data: Object.assign(Object.assign({}, args.data), { auth: Object.assign({ token: (_a = this.auth.session) === null || _a === void 0 ? void 0 : _a.accessToken }, (_b = args.data) === null || _b === void 0 ? void 0 : _b.auth) }) }), callback);
    }
    subscribe(args, callback) {
        return this.api.subscribe(args, callback);
    }
    request(args) {
        var _a, _b;
        return this.api.request(Object.assign(Object.assign({}, args), { data: Object.assign(Object.assign({}, args.data), { auth: Object.assign({ token: (_a = this.auth.session) === null || _a === void 0 ? void 0 : _a.accessToken }, (_b = args.data) === null || _b === void 0 ? void 0 : _b.auth) }) }));
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.api.close(),
                this.auth.api.close(),
            ]);
        });
    }
    destroy() {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
}
